import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { channelTestApi, setupGuideApi } from '@/api/setupGuide.api';

const KEY = ['setup-guide'] as const;

/** Home's guided setup checklist and trial (GET /api/setup-guide). */
export function useSetupGuide(enabled = true) {
  return useQuery({ queryKey: KEY, queryFn: setupGuideApi.get, staleTime: 0, enabled });
}

/** Skip a step, or bring a skipped one back. The response is the refreshed checklist. */
export function useSkipSetupStep() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { key: string; skip: boolean }) =>
      vars.skip ? setupGuideApi.skip(vars.key) : setupGuideApi.resume(vars.key),
    onSuccess: (data) => qc.setQueryData(KEY, data),
  });
}

/** Test messages through the company's own email / WhatsApp; a success ticks the checklist. */
export function useChannelTest() {
  const qc = useQueryClient();
  const onSuccess = () => qc.invalidateQueries({ queryKey: KEY });
  const email = useMutation({ mutationFn: (to?: string) => channelTestApi.email(to), onSuccess });
  const whatsApp = useMutation({ mutationFn: (to: string) => channelTestApi.whatsApp(to), onSuccess });
  return { email, whatsApp };
}
